import { Button } from "antd";
import { NeedHelp, PlusIcon } from "../../../atoms/CustomIcons";
import Header from "../../../atoms/Header";
import DashboardTemplate from "../../../templates/Dashboard";
import { SelectField } from "../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import EditableTable from "./Components/EditableTable";
interface FormValues {
  branch: string;
}

const branchList = [
  { label: "branch_1", value: "Branch 1" },
  { label: "branch_2", value: "Branch 2" },
];

export default function Holidays() {
  const { control } = useForm<FormValues>();

  return (
    <DashboardTemplate loading={false}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/:id` },
          { label: "Holidays" },
        ]}
        title="Holidays"
        description="Default days off on the crew scheduling board. You can opt in or out of default holidays and set custom ones."
        description2="You can also turn a holiday into a working day directly from the board when needed."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />

      <div className="maxWidth" style={{ maxWidth: "1000px" }}>
        <div className="HeaderControls">
          <div className="branchFilter">
            <SelectField
              fieldName="branch"
              label=""
              control={control}
              selectOption={branchList}
              iProps={{ placeholder: "Select branch" }}
              defaultValue="Branch"
            />
          </div>
          <Button
            onClick={(e) => {
              e.stopPropagation();
            }}
            type="primary"
            icon={<PlusIcon />}
          >
            Add holiday
          </Button>
        </div>
        <EditableTable />
      </div>
    </DashboardTemplate>
  );
}
